import { UsuarioViewModel } from './usuarioViewModel';
import { RolViewModel } from './rolViewModel';

export class ListadoUsuarios {
    usuarios: Array<UsuarioViewModel>;
    roles: Array<RolViewModel>;
    total: number;
    prevLink: string;
    nextLink: string;
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/models/viewmodels/listadoUsuarios.ts